<template>
    <v-dialog :model-value="modelValue" :max-width="350" persistent>
        <v-card>
            <v-card-title class="bg-blue">請用手機掃瞄條碼</v-card-title>
            <v-card-text>
                <v-img :src="qrCodeImgUrl" :width="250" class="mx-auto"></v-img>                
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script setup lang="ts">

const props = defineProps<{
    modelValue: boolean
    url: string,
    orderno: string
}>();
const emits = defineEmits<{
    (e: 'update:modelValue', v: boolean): void
}>();

const config = useRuntimeConfig();
const qrCodeImgUrl = computed(() => `${config.public.qrcodeUrl}${props.url}`);

nextTick(() => {

})

watch(() => props.orderno, (val) => {
    if (!!val) {
        setInterval(() => {
            useFetch(`/api/refreshdonateispay/scan2pay/${props.orderno}`, { method: "GET" })
                .then(res => {
                    if (!!res.data.value)
                        navigateTo(`/thank/${props.orderno}`);
                });
        }, 1000)
    }
})

</script>